import React from 'react'
import { TextInput } from 'components/Wizard2/fieldComponents/Form'
import { MASK } from 'components/Wizard2/validate'

export default ({ parentField: { options }, value, onChange }) => {
  const handleNumChange = (inputValue, name) => {
    const maskedValue = MASK.onlyNumbers(inputValue)
    if (typeof value[name] !== 'object') {
      onChange({
        ...value,
        [name]: {
          num: maskedValue,
          error: '',
        },
      })
    } else {
      onChange({
        ...value,
        [name]: {
          ...value[name],
          num: maskedValue,
        },
      })
    }
  }

  const handleErrorChange = (inputValue, name) => {
    if (typeof value[name] !== 'object') {
      onChange({
        ...value,
        [name]: {
          num: value[name],
          error: inputValue,
        },
      })
    } else {
      onChange({
        ...value,
        [name]: {
          ...value[name],
          error: inputValue,
        },
      })
    }
  }

  return (
    <React.Fragment>
      {options.map((option, i) => {
        return (
          <div key={option.value + i} className="select-option-constrainer">
            <label>{option.label}</label>
            <TextInput
              width="60px"
              value={
                typeof value[option.value] === 'object'
                  ? value[option.value].num
                  : value[option.value]
              }
              onChange={(value) => handleNumChange(value, option.value)}
            />
            <TextInput
              style={{ marginLeft: 5 }}
              width="auto"
              value={typeof value[option.value] === 'object' ? value[option.value].error : ''}
              onChange={(value) => handleErrorChange(value, option.value)}
              placeholder="Error message"
            />
          </div>
        )
      })}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/Designer2/SelectOptionConstrainer.js